import ipIntelligence from './my-MM/ipIntelligence';
import component from './my-MM/component';
import globalHeader from './my-MM/globalHeader';
import menu from './my-MM/menu';
import pages from './my-MM/pages';
import pwa from './my-MM/pwa';
import settingDrawer from './my-MM/settingDrawer';
import settings from './my-MM/settings';

export default {
  ...ipIntelligence,
  'navBar.lang': 'ဘာသာစကား',
  ...component,
  ...globalHeader,
  ...menu,
  ...pages,
  ...pwa,
  ...settingDrawer,
  ...settings,
};

